import { useState } from 'react';
import { Link } from 'react-router-dom';
import SuperAdminLayout from '../../../components/feature/SuperAdminLayout';

interface RevenueItem {
  id: string;
  type: 'subscription' | 'certificate';
  companyId: string;
  companyName: string;
  date: string;
  amount: number;
  commission: number;
  description: string;
  status: 'completed' | 'pending' | 'failed';
  paymentMethod?: string;
  plan?: string;
  certificateId?: string;
  studentName?: string;
}

export default function SuperAdminRevenue() {
  const [revenueItems] = useState<RevenueItem[]>([
    {
      id: 'REV-2024-001',
      type: 'subscription',
      companyId: 'COMP-001',
      companyName: '한국디지털교육원',
      date: '2024-01-15',
      amount: 99000,
      commission: 99000,
      description: 'Pro 플랜 월간 구독',
      status: 'completed',
      paymentMethod: '신용카드',
      plan: 'Pro'
    },
    {
      id: 'REV-2024-002',
      type: 'certificate',
      companyId: 'COMP-001',
      companyName: '한국디지털교육원',
      date: '2024-01-16',
      amount: 5000,
      commission: 750,
      description: '유료 수료증 발급',
      status: 'completed',
      paymentMethod: '신용카드',
      certificateId: 'CERT-2024-156',
      studentName: '김학습'
    },
    {
      id: 'REV-2024-003',
      type: 'subscription',
      companyId: 'COMP-002',
      companyName: '서울IT아카데미',
      date: '2024-01-17',
      amount: 29000,
      commission: 29000,
      description: 'Basic 플랜 월간 구독',
      status: 'completed',
      paymentMethod: '계좌이체',
      plan: 'Basic'
    },
    {
      id: 'REV-2024-004',
      type: 'certificate',
      companyId: 'COMP-003',
      companyName: '부산교육센터',
      date: '2024-01-18',
      amount: 8000,
      commission: 1200,
      description: '유료 수료증 발급',
      status: 'completed',
      paymentMethod: '신용카드',
      certificateId: 'CERT-2024-157',
      studentName: '이수료'
    },
    {
      id: 'REV-2024-005',
      type: 'subscription',
      companyId: 'COMP-004',
      companyName: '대전직업전문학교',
      date: '2024-01-19',
      amount: 99000,
      commission: 99000,
      description: 'Pro 플랜 월간 구독',
      status: 'pending',
      paymentMethod: '계좌이체',
      plan: 'Pro'
    },
    {
      id: 'REV-2024-006',
      type: 'certificate',
      companyId: 'COMP-002',
      companyName: '서울IT아카데미',
      date: '2024-01-20',
      amount: 3000,
      commission: 450,
      description: '유료 수료증 발급',
      status: 'completed',
      paymentMethod: '신용카드',
      certificateId: 'CERT-2024-158',
      studentName: '박완료'
    },
    {
      id: 'REV-2024-007',
      type: 'subscription',
      companyId: 'COMP-005',
      companyName: '광주평생교육원',
      date: '2024-01-21',
      amount: 29000,
      commission: 29000,
      description: 'Basic 플랜 월간 구독',
      status: 'completed',
      paymentMethod: '신용카드',
      plan: 'Basic'
    },
    {
      id: 'REV-2024-008',
      type: 'certificate',
      companyId: 'COMP-001',
      companyName: '한국디지털교육원',
      date: '2024-01-22',
      amount: 7000,
      commission: 1050,
      description: '유료 수료증 발급',
      status: 'completed',
      paymentMethod: '신용카드',
      certificateId: 'CERT-2024-159',
      studentName: '최교육'
    },
    {
      id: 'REV-2024-009',
      type: 'subscription',
      companyId: 'COMP-006',
      companyName: '인천기술교육원',
      date: '2024-01-23',
      amount: 99000,
      commission: 99000,
      description: 'Pro 플랜 월간 구독',
      status: 'failed',
      paymentMethod: '신용카드',
      plan: 'Pro'
    },
    {
      id: 'REV-2024-010',
      type: 'certificate',
      companyId: 'COMP-003',
      companyName: '부산교육센터',
      date: '2024-01-24',
      amount: 10000,
      commission: 1500,
      description: '유료 수료증 발급',
      status: 'completed',
      paymentMethod: '계좌이체',
      certificateId: 'CERT-2024-160',
      studentName: '정학습'
    },
    {
      id: 'REV-2024-011',
      type: 'certificate',
      companyId: 'COMP-001',
      companyName: '한국디지털교육원',
      date: '2024-01-25',
      amount: 4000,
      commission: 600,
      description: '유료 수료증 발급',
      status: 'completed',
      paymentMethod: '계좌이체',
      certificateId: 'CERT-2024-161',
      studentName: '한지민'
    },
    {
      id: 'REV-2024-012',
      type: 'certificate',
      companyId: 'COMP-002',
      companyName: '서울IT아카데미',
      date: '2024-01-26',
      amount: 6000,
      commission: 900,
      description: '유료 수료증 발급',
      status: 'completed',
      paymentMethod: '신용카드',
      certificateId: 'CERT-2024-162',
      studentName: '송민호'
    },
    {
      id: 'REV-2024-013',
      type: 'certificate',
      companyId: 'COMP-003',
      companyName: '부산교육센터',
      date: '2024-01-27',
      amount: 2000,
      commission: 300,
      description: '유료 수료증 발급',
      status: 'completed',
      paymentMethod: '계좌이체',
      certificateId: 'CERT-2024-163',
      studentName: '김하늘'
    }
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [typeFilter, setTypeFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [selectedItem, setSelectedItem] = useState<RevenueItem | null>(null);
  const [showDetailModal, setShowDetailModal] = useState(false);

  const filteredItems = revenueItems.filter(item => {
    const matchesSearch = item.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType = typeFilter === 'all' || item.type === typeFilter;
    const matchesStatus = statusFilter === 'all' || item.status === statusFilter;
    const matchesDateRange = (!dateRange.start || item.date >= dateRange.start) &&
                            (!dateRange.end || item.date <= dateRange.end);
    
    return matchesSearch && matchesType && matchesStatus && matchesDateRange;
  });

  const totalRevenue = filteredItems
    .filter(item => item.status === 'completed')
    .reduce((sum, item) => sum + item.commission, 0);

  const subscriptionRevenue = filteredItems
    .filter(item => item.type === 'subscription' && item.status === 'completed')
    .reduce((sum, item) => sum + item.commission, 0);

  const certificateRevenue = filteredItems
    .filter(item => item.type === 'certificate' && item.status === 'completed')
    .reduce((sum, item) => sum + item.commission, 0);

  const pendingRevenue = filteredItems
    .filter(item => item.status === 'pending')
    .reduce((sum, item) => sum + item.commission, 0);

  const getTypeColor = (type: string) => {
    switch (type) {
      case 'subscription': return 'bg-blue-100 text-blue-800';
      case 'certificate': return 'bg-green-100 text-green-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getTypeText = (type: string) => {
    switch (type) {
      case 'subscription': return '구독';
      case 'certificate': return '수료증';
      default: return type;
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed': return 'bg-green-100 text-green-800';
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'failed': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'completed': return '완료';
      case 'pending': return '대기중';
      case 'failed': return '실패';
      default: return status;
    }
  };

  const handleViewDetail = (item: RevenueItem) => {
    setSelectedItem(item);
    setShowDetailModal(true);
  };

  const resetFilters = () => {
    setSearchTerm('');
    setTypeFilter('all');
    setStatusFilter('all');
    setDateRange({ start: '', end: '' });
  };

  return (
    <SuperAdminLayout>
      <div className="min-h-screen bg-gray-50">
        {/* 헤더 */}
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-6 py-4">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-bold text-gray-900">수익 상세 내역</h1>
                <p className="text-sm text-gray-600">구독 결제 및 유료 수료증 발급 내역을 관리합니다</p>
              </div>
              <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-download-line mr-2"></i>
                엑셀 다운로드
              </button>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-6 py-6">
        {/* 통계 카드 */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-money-dollar-circle-line text-2xl text-blue-600"></i>
              </div>
              <div>
                <p className="text-sm text-gray-600">총 수익</p>
                <p className="text-2xl font-bold text-gray-900">₩{totalRevenue.toLocaleString()}</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-vip-crown-line text-2xl text-purple-600"></i>
              </div>
              <div>
                <p className="text-sm text-gray-600">구독 수익</p>
                <p className="text-2xl font-bold text-gray-900">₩{subscriptionRevenue.toLocaleString()}</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-file-text-line text-2xl text-green-600"></i>
              </div>
              <div>
                <p className="text-sm text-gray-600">수료증 수수료</p>
                <p className="text-2xl font-bold text-gray-900">₩{certificateRevenue.toLocaleString()}</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-time-line text-2xl text-yellow-600"></i>
              </div>
              <div>
                <p className="text-sm text-gray-600">대기중 수익</p>
                <p className="text-2xl font-bold text-gray-900">₩{pendingRevenue.toLocaleString()}</p>
              </div>
            </div>
          </div>
        </div>

        {/* 필터 및 검색 */}
        <div className="bg-white rounded-lg shadow mb-6">
          <div className="p-6 border-b border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">검색</label>
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="고객사명, 내역 ID"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">유형</label>
                <select
                  value={typeFilter}
                  onChange={(e) => setTypeFilter(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8 text-sm"
                >
                  <option value="all">전체</option>
                  <option value="subscription">구독</option>
                  <option value="certificate">수료증</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">상태</label>
                <select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8 text-sm"
                >
                  <option value="all">전체</option>
                  <option value="completed">완료</option>
                  <option value="pending">대기중</option>
                  <option value="failed">실패</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">시작일</label>
                <input
                  type="date"
                  value={dateRange.start}
                  onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">종료일</label>
                <input
                  type="date"
                  value={dateRange.end}
                  onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                />
              </div>
            </div>

            <div className="mt-4 flex justify-end">
              <button
                onClick={resetFilters}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-refresh-line mr-2"></i>
                초기화
              </button>
            </div>
          </div>

          {/* 수익 내역 테이블 */}
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    내역 ID
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    유형
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    고객사
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    내용
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    결제금액 / 수수료
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    결제일
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    상태
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    액션
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredItems.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-mono text-blue-600">{item.id}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getTypeColor(item.type)}`}>
                        {getTypeText(item.type)}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm font-medium text-gray-900">{item.companyName}</div>
                      <div className="text-sm text-gray-500">{item.companyId}</div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm text-gray-900">{item.description}</div>
                      {item.studentName && (
                        <div className="text-sm text-gray-500">학습자: {item.studentName}</div>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {item.type === 'subscription' ? (
                        <div>
                          <div className="text-sm text-gray-500">구독료</div>
                          <div className="text-sm font-bold text-blue-600">
                            ₩{item.amount.toLocaleString()}
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div className="text-sm text-gray-500">
                            판매액: ₩{item.amount.toLocaleString()}
                          </div>
                          <div className="text-sm font-bold text-blue-600">
                            수수료: ₩{item.commission.toLocaleString()}
                          </div>
                        </div>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">{item.date}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(item.status)}`}>
                        {getStatusText(item.status)}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <button
                        onClick={() => handleViewDetail(item)}
                        className="text-blue-600 hover:text-blue-900 text-sm whitespace-nowrap cursor-pointer"
                      >
                        상세보기
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {filteredItems.length === 0 && (
            <div className="text-center py-12">
              <i className="ri-file-list-3-line text-4xl text-gray-400 mb-4"></i>
              <h3 className="text-lg font-medium text-gray-900 mb-2">수익 내역이 없습니다</h3>
              <p className="text-gray-500">검색 조건을 변경해보세요.</p>
            </div>
          )}
        </div>
      </div>

      {/* 상세 정보 모달 */}
      {showDetailModal && selectedItem && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-medium text-gray-900">수익 상세 정보</h3>
                <button
                  onClick={() => setShowDetailModal(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
            </div>

            <div className="p-6">
              {/* 기본 정보 */}
              <div className="mb-6">
                <h4 className="text-sm font-medium text-gray-900 mb-3">기본 정보</h4>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-500 mb-1">내역 ID</label>
                    <p className="text-sm text-gray-900 font-mono">{selectedItem.id}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-500 mb-1">유형</label>
                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getTypeColor(selectedItem.type)}`}>
                      {getTypeText(selectedItem.type)}
                    </span>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-500 mb-1">결제일</label>
                    <p className="text-sm text-gray-900">{selectedItem.date}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-500 mb-1">상태</label>
                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(selectedItem.status)}`}>
                      {getStatusText(selectedItem.status)}
                    </span>
                  </div>
                </div>
              </div>

              {/* 고객사 정보 */}
              <div className="mb-6">
                <h4 className="text-sm font-medium text-gray-900 mb-3">고객사 정보</h4>
                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-500 mb-1">고객사명</label>
                      <p className="text-sm text-gray-900 font-medium">{selectedItem.companyName}</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-500 mb-1">고객사 ID</label>
                      <p className="text-sm text-gray-900 font-mono">{selectedItem.companyId}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 수익 정보 */}
              <div className="mb-6">
                <h4 className="text-sm font-medium text-gray-900 mb-3">수익 정보</h4>
                <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-lg p-4 border border-blue-200">
                  {selectedItem.type === 'subscription' ? (
                    <div className="space-y-3">
                      <div className="flex justify-between items-center">
                        <label className="block text-sm font-medium text-gray-700">구독료 (전액 수익)</label>
                        <p className="text-xl font-bold text-blue-600">₩{selectedItem.amount.toLocaleString()}</p>
                      </div>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      <div className="flex justify-between items-center">
                        <label className="block text-sm font-medium text-gray-700">판매 금액</label>
                        <p className="text-lg font-bold text-gray-900">₩{selectedItem.amount.toLocaleString()}</p>
                      </div>
                      <div className="flex justify-between items-center">
                        <label className="block text-sm font-medium text-gray-700">
                          플랫폼 수수료 (15%)
                        </label>
                        <p className="text-xl font-bold text-blue-600">₩{selectedItem.commission.toLocaleString()}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* 결제 정보 */}
              <div className="mb-6">
                <h4 className="text-sm font-medium text-gray-900 mb-3">결제 정보</h4>
                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-500 mb-1">결제 금액</label>
                      <p className="text-lg font-bold text-gray-900">₩{selectedItem.amount.toLocaleString()}</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-500 mb-1">
                        {selectedItem.type === 'subscription' ? '수익' : '수수료'}
                      </label>
                      <p className="text-lg font-bold text-blue-600">₩{selectedItem.commission.toLocaleString()}</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-500 mb-1">결제 방법</label>
                      <p className="text-sm text-gray-900">{selectedItem.paymentMethod || '-'}</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-500 mb-1">수수료율</label>
                      <p className="text-sm text-gray-900">
                        {selectedItem.type === 'subscription' ? '100%' : '15%'}
                      </p>
                    </div>
                    <div className="col-span-2">
                      <label className="block text-sm font-medium text-gray-500 mb-1">내용</label>
                      <p className="text-sm text-gray-900">{selectedItem.description}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 구독 정보 (구독 타입인 경우) */}
              {selectedItem.type === 'subscription' && selectedItem.plan && (
                <div className="mb-6">
                  <h4 className="text-sm font-medium text-gray-900 mb-3">구독 정보</h4>
                  <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-500 mb-1">플랜</label>
                        <p className="text-sm text-gray-900 font-medium">{selectedItem.plan}</p>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-500 mb-1">결제 주기</label>
                        <p className="text-sm text-gray-900">월간</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* 수료증 정보 (수료증 타입인 경우) */}
              {selectedItem.type === 'certificate' && selectedItem.certificateId && (
                <div className="mb-6">
                  <h4 className="text-sm font-medium text-gray-900 mb-3">수료증 정보</h4>
                  <div className="bg-green-50 rounded-lg p-4 border border-green-200">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-500 mb-1">수료증 ID</label>
                        <p className="text-sm text-gray-900 font-mono">{selectedItem.certificateId}</p>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-500 mb-1">학습자명</label>
                        <p className="text-sm text-gray-900">{selectedItem.studentName || '-'}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end gap-3">
              <button
                onClick={() => setShowDetailModal(false)}
                className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                닫기
              </button>
              <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-printer-line mr-2"></i>
                영수증 출력
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  </SuperAdminLayout>
  );
}
